<div #kanbanDefaultSwimlane>

  <div id="daily-main-container">

    <!-- Column-Headings -->
    <div *ngIf="this.data.boardConfiguration" class="column-headers">
      <div *ngFor="let column of this.data.boardConfiguration.columns"
           class="kanban-column board-column--headers">

        <div class="column-name">{{column.name}}</div>

        <div class="wip-limit"
             [ngClass]="{ 'wip-limit': true,
                          'exceeded': column.current > column.max,
                          'no-limit': !column.max} ">
          {{column.current}} /
          <span *ngIf="column.max; else inifiteIssues">{{column.max}}</span>
          <ng-template #inifiteIssues>∞</ng-template>
        </div>
      </div>
    </div>

    <!-- Expedite Lane -->
    <div class="expedite-lane" *ngIf="data.expediteLane" [ngClass]="{ 'open': this.data.expediteLane }">
      <div *ngFor="let rowData of expediteLaneData"
           [ngClass]="{'transparent-background' : this.backgroundVideoIsActive}"
           class="userstory-row" id="story-id-{{rowData.userstory.id}}-expedite">

        <div class="userstory-row__cardcontainer" cdkDropListGroup>

          <div *ngFor="let column of rowData.columns" cdkDropList
               class="daily-column issue-list board-column kanban-column"
               [cdkDropListData]="column"
               [cdkDropListConnectedTo]="['addToBoard-'+column.id, 'productbacklog']"
               (cdkDropListDropped)="onIssueDropped($event, true)"
               [attr.data-columnname]="column.name"
               [attr.data-columnid]="column.id"
               [attr.data-columntype]="column.type"
          >

            <app-kanban-taskcard *ngFor="let task of column.tasks"
                                 [task]="task"
                                 class="issue-list-element teamwidgetdropzone imagedropzone whiteboarddropzone stickerdropzone"
                                 cdkDrag
                                 [ngClass]="{'parent-issue': (!task.isSubissue),'sub-issue':(task.isSubissue)}"
                                 (cdkDragReleased)="onCardReleased($event)"
                                 (cdkDragMoved)="onCardMoved($event)"
                                 (dblclick)="this.onIssueDoubleClicked($event, task)"
                                 [cdkDragData]="task"
                                 [attr.data-taskcardid]="task.id"
                                 [attr.data-highlightcolor]="task.highlightColor"
                                 [kanbanBoardViewComponent]="this.data.parent">
              <div *cdkDragPreview class="custom-drag-preview">
                <div class="issue-list-element">{{task.summary}}</div>
              </div>
            </app-kanban-taskcard>
          </div>
        </div>

        <a class="userstory-row__addsubtask" (click)="createSubtask(rowData.userstory.id)">+ Add
          subtask</a>
      </div>

      <!-- Dropzone lane for issues being moved from backlog / board -->
      <div class="userstory-row">
        <div class="userstory-row__cardcontainer issueTempDropzone">
          <div *ngFor="let column of this.taskboardData[0].columns" cdkDropList
               class="daily-column issue-list board-column kanban-column"
               id="addToExpediteLane-{{column.id}}"
               [cdkDropListData]="column"
               (cdkDropListDropped)="onIssueDropped($event, true)"
               [attr.data-columnname]="column.name"
               [attr.data-columnid]="column.id"
               [attr.data-columntype]="column.type">
          </div>
        </div>
      </div>
    </div>

    <!-- Dropzone lane for issues being moved from backlog / expedite lane -->
    <div class="userstory-row">
      <div class="userstory-row__cardcontainer issueTempDropzone">
        <div *ngFor="let column of this.taskboardData[0].columns" cdkDropList
             class="daily-column issue-list board-column kanban-column"
             id="addToBoard-{{column.id}}"
             [cdkDropListData]="column"
             (cdkDropListDropped)="onIssueDropped($event, false)"
             [attr.data-columnname]="column.name"
             [attr.data-columnid]="column.id"
             [attr.data-columntype]="column.type">
        </div>
      </div>
    </div>

    <div class="scroll">
    <!-- Normal Lanes -->
    <div *ngFor="let rowData of taskboardData"
         [ngClass]="{'transparent-background' : this.backgroundVideoIsActive}"
         class="userstory-row" id="story-id-{{rowData.userstory.id}}">

      <div class="userstory-row__cardcontainer" cdkDropListGroup>

        <div *ngFor="let column of rowData.columns" cdkDropList
             class="daily-column issue-list board-column kanban-column"
             id="{{column.id}}-{{rowData.userstory.id}}"
             [cdkDropListConnectedTo]="['addToExpediteLane-'+column.id,  'productbacklog']"
             [cdkDropListData]="column"
             (cdkDropListDropped)="onIssueDropped($event, false)"
             [attr.data-columnname]="column.name"
             [attr.data-columnid]="column.id"
             [attr.data-columntype]="column.type"
        >

          <app-kanban-taskcard *ngFor="let task of column.tasks"
                               [task]="task"
                               class="issue-list-element teamwidgetdropzone imagedropzone whiteboarddropzone stickerdropzone"
                               cdkDrag
                               [ngClass]="{'parent-issue': (!task.isSubissue),'sub-issue':(task.isSubissue)}"
                               (cdkDragReleased)="onCardReleased($event)"
                               (cdkDragMoved)="onCardMoved($event)"
                               (dblclick)="this.onIssueDoubleClicked($event, task)"
                               [cdkDragData]="task"
                               [attr.data-taskcardid]="task.id"
                               [attr.data-highlightcolor]="task.highlightColor"
                               [attr.data-columntype]="rowData.userstory.status.statusCategory.key"
                               [kanbanBoardViewComponent]="this.data.parent">
            <div *cdkDragPreview class="custom-drag-preview">
              <div class="issue-list-element">{{task.summary}}</div>
            </div>
          </app-kanban-taskcard>


        </div>
      </div>

      <a class="userstory-row__addsubtask" (click)="createSubtask(rowData.userstory.id)">+ Add
        subtask</a>
    </div>
    </div>
  </div>
</div>
